import style from './statusList.module.css';

import { ReactComponent as StartIcon } from 'assets/svg/start.svg';
import { ReactComponent as StopIcon } from 'assets/svg/stop.svg';
import { ReactComponent as ClockIcon } from 'assets/svg/animationClock.svg';
import { ReactComponent as InfoIcon } from 'assets/svg/info_outline.svg';
import StorageIcon from 'assets/svg/storage-01.svg';
import QualityControlIcon from 'assets/svg/quality-control-01.svg';

import { memo, useEffect, useState } from 'react';
import Icon from 'ui/Icon';
import Tooltip from 'ui/Tooltip';
import { PUBLIC_ASSETS, address_server_short } from 'config';
import ProgressArrow from 'ui/ProgressArrow';
import { SchemeNodeTypes, StatusIteration } from 'consts/scheme.consts';
import StageStopModal from '../StageStopModal';
import StageInfoModal from '../StageInfoModal';
import StageStartModal from '../StageStartModal';
import StageQualityStopModal from '../StageQualityStopModal';
import classNames from 'classnames';
import StageQualityStartModal from '../StageQualityStartModal';
import { productionStore } from 'store/mobx/production.store';

const Iteration = ({ item, objects, status, childrenArray }) => {
  const { latestStartedProcessId, setLatestStartedProcessId } = productionStore;
  const [statusText, setStatusText] = useState('');
  const [openStopModal, setOpenStopModal] = useState(false);
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [openStartModal, setOpenStartModal] = useState(false);

  useEffect(() => {
    if (latestStartedProcessId && item.id === latestStartedProcessId) {
      setOpenInfoModal(true);
      setLatestStartedProcessId(null);
    }
  }, []);

  useEffect(() => {
    switch (status) {
      case StatusIteration.InProgress:
        setStatusText('В процессе');
        break;
      case StatusIteration.NotStarted:
        setStatusText('Готово к работе');
        break;
      default:
        setStatusText('Неизвестный статус');
        break;
    }
  }, [status]);

  return (
    <div className={style.rowContainer}>
      <div className={style.buttonContainer}>
        <InfoIcon className={style.infoIcon} onClick={() => setOpenInfoModal(true)} />
        <StopIcon
          className={classNames(style.stopIcon, {
            [style.disabled]: status === StatusIteration.NotStarted,
          })}
          onClick={() => status !== StatusIteration.NotStarted && setOpenStopModal(true)}
        />
        {status === StatusIteration.NotStarted ? (
          <StartIcon className={style.startIcon} onClick={() => setOpenStartModal(true)} />
        ) : (
          <ClockIcon className={style.awaitIcon} />
        )}
      </div>

      <div style={{ display: 'flex', gap: '5px' }}>
        {objects?.map((object, index) => (
          <div key={index} className={style.sample}>
            <Tooltip text={object.name}>
              <Icon
                width="44px"
                height="44px"
                src={address_server_short + PUBLIC_ASSETS + (object?.image ?? '')}
              />
            </Tooltip>
          </div>
        ))}
      </div>

      <ProgressArrow variant={status === StatusIteration.NotStarted ? 'primary' : 'accent'} />
      <div className={style.status}>{statusText}</div>
      <ProgressArrow variant={status === StatusIteration.NotStarted ? 'primary' : 'accent'} />
      <div style={{ display: 'flex', gap: '5px' }}>
        {item?.type !== SchemeNodeTypes?.qualityControl ? (
          childrenArray?.map((obj, index) => {
            if (obj.type === 'storage')
              return (
                <div key={index} className={style.sample}>
                  <Tooltip text={obj.name}>
                    <Icon width="44px" height="44px" src={StorageIcon} />
                  </Tooltip>
                </div>
              );
            else
              return (
                <div key={index} className={style.sample}>
                  <Tooltip text={obj.name}>
                    <Icon
                      width="44px"
                      height="44px"
                      color={''}
                      src={address_server_short + PUBLIC_ASSETS + (obj?.image ?? '')}
                    />
                  </Tooltip>
                </div>
              );
          })
        ) : (
          <div className={style.sample}>
            <Tooltip text={item.protocol?.name}>
              <Icon width="44px" height="44px" src={QualityControlIcon} />
            </Tooltip>
          </div>
        )}
      </div>
      {item?.type !== SchemeNodeTypes?.qualityControl ? (
        <>
          <StageStopModal open={openStopModal} setOpen={setOpenStopModal} node={item} />
          <StageStartModal open={openStartModal} setOpen={setOpenStartModal} node={item} />
        </>
      ) : (
        <>
          <StageQualityStopModal node={item} open={openStopModal} setOpen={setOpenStopModal} />
          <StageQualityStartModal node={item} open={openStartModal} setOpen={setOpenStartModal} />
        </>
      )}
      <StageInfoModal open={openInfoModal} setOpen={setOpenInfoModal} node={item} />
    </div>
  );
};

export default memo(Iteration);
